import { LabelMapper, VatReleaseReason } from 'types';
import { settingsTexts } from 'consts/text';

export const settlementVatReleaseReasonLabels: LabelMapper<VatReleaseReason> = {
    [VatReleaseReason.CUSTOM]: settingsTexts.settlements.vatRates.vatReleaseReasonLabels.custom,
    [VatReleaseReason.ART_43_1]: settingsTexts.settlements.vatRates.vatReleaseReasonLabels.art43_1,
    [VatReleaseReason.ART_82_3]: settingsTexts.settlements.vatRates.vatReleaseReasonLabels.art82_3,
    [VatReleaseReason.ART_113_1_9]:
        settingsTexts.settlements.vatRates.vatReleaseReasonLabels.art113_1_9,
};
